import { homeRouterMap, projectRouterMap } from '@/config/router.config'
import Vue from 'vue'
import store from '@/store'

function hasPermission (route, permissions) {
  var accessPermission = route.meta && route.meta.permission || undefined
  if (accessPermission == undefined || accessPermission.length == 0) return true
  for (let i = 0; i < permissions.length; i++) {
    if (permissions[i] == accessPermission) return true
  }
  return false
}

function filterAsyncRouter (routerMap, permissions) {
  const accessedRouters = []
  for (var i = 0; i < routerMap.length; i++) {
    if (hasPermission(routerMap[i], permissions)) {
      var temp = Object.assign({}, routerMap[i])
      if (routerMap[i].children && routerMap[i].children.length != 0) {
        temp.children = filterAsyncRouter(routerMap[i].children, permissions)
      }
      accessedRouters.push(temp)
    }
  }
  return accessedRouters
}

const permission = {
  state: {
    menus: [], // menu显示相关路由表
    homePagePermission: [],
    projectPagePermission: [],
    homeRouters: [],
    projectRouters: []
  },
  mutations: {
    SET_HOME_ROUTERS: (state, homeRouters) => {
      state.homeRouters = homeRouters
      state.menus = homeRouters[0].children
    },
    SET_PROJECT_ROUTERS: (state, projectRouters) => {
      state.projectRouters = projectRouters
      state.menus = projectRouters[0].children
    },
    CONVERT_PAGE: (state, page) => {
      switch (page) {
        case 'homePage':

          state.menus = state.homeRouters[0].children
          break
        case 'projectPage':

          state.menus = state.projectRouters[0] ? state.projectRouters[0].children : []
          break
        default:
          state.menus = []
      }
    },
    CLEAN_PERMISSIONS: (state) => {
      Object.assign(state, {
        menus: [], // menu显示相关路由表
        homeRouters: [],
        projectRouters: []
      })
    }
  },
  actions: {
    GenerateHomeRoutes ({ commit }, permissions) {
      return new Promise(resolve => {
        const homeRouters = filterAsyncRouter(homeRouterMap.concat(), permissions)
        commit('SET_HOME_ROUTERS', homeRouters)
        resolve()
      })
    },
    GenerateProjectRoutes ({ commit }, permissions) {
      return new Promise(resolve => {
        const projectRouters = filterAsyncRouter(projectRouterMap.concat([]), permissions)
        commit('SET_PROJECT_ROUTERS', projectRouters)
        resolve()
      })
    },
    ConvertPage ({ commit }, page) {
      commit('CONVERT_PAGE', page)
    },
    CleanPermissions ({ commit }) {
      commit('CLEAN_PERMISSIONS')
    }
  }
}

export default permission
